import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AdvEditorIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 20 20"
    >
      <path
        d="M8.29189 14.7501L19.4502 3.59176C19.7586 3.28343 19.9336 2.86676 19.9336 2.43343C19.9336 2.0001 19.7586 1.58343 19.4502 1.26676L18.7336 0.550098C18.0919 -0.091569 17.0502 -0.091569 16.4086 0.550098L5.25023 11.7084C5.13356 11.8251 5.06689 11.9834 5.06689 12.1501V14.3084C5.06689 14.6501 5.35023 14.9334 5.69189 14.9334H7.85023C8.01689 14.9334 8.17523 14.8668 8.29189 14.7501ZM6.31689 13.6834V12.4084L17.2919 1.43343C17.4419 1.28343 17.6919 1.28343 17.8502 1.43343L18.5669 2.1501C18.7169 2.3001 18.7169 2.55843 18.5669 2.70843L7.59189 13.6834H6.31689Z"
        fill={color}
      />
      <path
        d="M8.22503 17.25H7.38337C7.09802 17.25 6.8667 17.4813 6.8667 17.7667V18.6083C6.8667 18.8937 7.09802 19.125 7.38337 19.125H8.22503C8.51038 19.125 8.7417 18.8937 8.7417 18.6083V17.7667C8.7417 17.4813 8.51038 17.25 8.22503 17.25Z"
        fill={color}
      />
      <path
        d="M16.4164 15.0581H15.5748C15.2894 15.0581 15.0581 15.2894 15.0581 15.5748V16.4164C15.0581 16.7018 15.2894 16.9331 15.5748 16.9331H16.4164C16.7018 16.9331 16.9331 16.7018 16.9331 16.4164V15.5748C16.9331 15.2894 16.7018 15.0581 16.4164 15.0581Z"
        fill={color}
      />
      <path
        d="M12.7665 17.8667H11.9249C11.6395 17.8667 11.4082 18.098 11.4082 18.3834V19.225C11.4082 19.5104 11.6395 19.7417 11.9249 19.7417H12.7665C13.0519 19.7417 13.2832 19.5104 13.2832 19.225V18.3834C13.2832 18.098 13.0519 17.8667 12.7665 17.8667Z"
        fill={color}
      />
      <path
        d="M19.225 11.4082H18.3834C18.098 11.4082 17.8667 11.6395 17.8667 11.9249V12.7665C17.8667 13.0519 18.098 13.2832 18.3834 13.2832H19.225C19.5104 13.2832 19.7417 13.0519 19.7417 12.7665V11.9249C19.7417 11.6395 19.5104 11.4082 19.225 11.4082Z"
        fill={color}
      />
      <path
        d="M18.725 7.2832H17.8834C17.598 7.2832 17.3667 7.51452 17.3667 7.79987V8.64154C17.3667 8.92688 17.598 9.1582 17.8834 9.1582H18.725C19.0104 9.1582 19.2417 8.92688 19.2417 8.64154V7.79987C19.2417 7.51452 19.0104 7.2832 18.725 7.2832Z"
        fill={color}
      />
      <path
        d="M3.30847 15.3668L1.52513 8.70013C1.35013 8.05013 1.5418 7.35847 2.00847 6.8918L6.8918 2.00847C7.35847 1.5418 8.05013 1.35013 8.70013 1.52513L12.3418 2.50013C12.6835 2.5918 13.0168 2.3918 13.1085 2.05847C13.2001 1.72513 13.0001 1.38347 12.6668 1.2918L9.02513 0.3168C7.95013 0.0334671 6.7918 0.341801 6.00847 1.12513L1.12513 6.00013C0.341801 6.78347 0.0334671 7.9418 0.3168 9.0168L2.10847 15.6835C2.25013 16.2085 2.52513 16.6918 2.9168 17.0835C3.15847 17.3251 3.55847 17.3251 3.80013 17.0835C4.0418 16.8418 4.0418 16.4418 3.80013 16.2001C3.5668 15.9668 3.40013 15.6751 3.3168 15.3585L3.30847 15.3668Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AdvEditorIcon.displayName = 'AdvEditorIcon';
